export default {
  anonymous: () => import("/home/circleci/sleuth/frontend/layouts/anonymous.vue"),
  default: () => import("/home/circleci/sleuth/frontend/layouts/default.vue"),
  modal: () => import("/home/circleci/sleuth/frontend/layouts/modal.vue")
}